import React from 'react';
import { Input, useT } from '@repo/common';

const TargetRoleInputBlock = ({
  value,
  focused,
  inputRef,
  state,
  onChange,
  onFocus,
  onBlur,
}) => {
  const t = useT();

  return (
    <div className='relative min-w-[260px] w-full'>
      <Input
        id='korean-name-input'
        ref={inputRef}
        label={focused ? t('Target role', '희망 직무') : ''}
        value={value}
        state={state}
        hideCount
        showStatusIcon={false}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={t('e.g. Visual designer', '예: 비주얼 디자이너')}
        className='placeholder:opacity-0 w-full md:max-w-[380px]'
      />
    </div>
  );
};

export default TargetRoleInputBlock;
